// extracted by mini-css-extract-plugin
export default {"detailed-program-page-content":"DetailedProgramPageContent_detailed-program-page-content__KtCDi","sections-list":"DetailedProgramPageContent_sections-list__zSzED"};